module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/specilization/specilization.component.html
// module id = ./src/app/Pages/manage/specilization/specilization.component.html
// module chunks = main